export const NOTIFICATION_FLASHING_INTERVAL = 750;
